import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Dashboards({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'All Luminr Dashboards'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

